import SlButton from '../SlButton';
import styles from './style.module.css';

// Step 29: the global "main-default-border-color text-black" classes are
// gone from the class list (they forced a grey outline and black text over
// the owner's purple buttons). Handlers and props pass through unchanged.
export default function HeaderButton({ children, className, ...rest }) {
   return (
      <SlButton
         className={`w-max my-auto ${className} ${styles.header_button}`}
         {...rest}
      >
         {children}
      </SlButton>
   );
}
